import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';
import { IEICFTemplate } from '../EICFTemplate.ts';

export function useApproveEICFTemplate() {
    const queryClient = useQueryClient();
    return useMutation<IEICFTemplate, AppMedError, number>({
        mutationKey: [QueryKeys.eicfTemplates, 'approve'],
        mutationFn: (id) => EICFTemplatesApi.approve(id),
        onSuccess: (_data, id) => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.eicfTemplates] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.eicfTemplate, id] });
        },
    });
}
